import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  codigo: Yup.string().min(2).max(5).required(),
  nombre: Yup.string().min(1).max(120).required()
})
